import React, { useContext, useRef, useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { initTWE } from 'tw-elements';
import { Icon } from '@iconify/react';
//import { Menu, X, ChevronDown } from 'lucide-react';
import SimpleBar from 'simplebar';
import Draggable from 'react-draggable';

import 'simplebar-react/dist/simplebar.min.css';

import { AuthContext, useAuth } from '../context/AuthContext';
import Navbar from './common/Navbar';

const Layout = ({ children }) => {
  
  const { pathname } = useLocation();
  const isActive = (path) => pathname === path;

  const { user } = useContext(AuthContext);
  const scrollRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const [openNav, setOpenNav] = useState(false);
  const [openDrop, setOpenDrop] = useState(false);
  
  // Logout
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log('Cerrando sesión...');

    logout();
    setTimeout(() => {
      navigate('/login');
    }, 0);
  };
  

  // Estado para notificaciones (draggable)
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  


  // Estado para dropdown perfil usuario
  const [open2, setOpen2] = useState(false);
  // Define refs separados
  const dropdownPerfilRef = useRef(null);
  const dropdownCatalogosRef = useRef(null);

// useEffect para cerrar dropdowns al click fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownPerfilRef.current && !dropdownPerfilRef.current.contains(event.target)
      ) {
        setOpen2(false);
      }
      if (
        dropdownCatalogosRef.current && !dropdownCatalogosRef.current.contains(event.target)
      ) {
        setOpenDrop(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  // Inicialización SimpleBar e initTWE
  useEffect(() => {
    if (scrollRef.current) {
      new SimpleBar(scrollRef.current);
    }
    initTWE();
  }, []);

  // Cerrar dropdown notificaciones al click afuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


    

  // Toggle dropdown notificaciones solo si no está draggeando
  const handleToggle = () => {
    if (!dragging) {
      setOpen((prev) => !prev);
    }
  };

  return (
      <main className="app-wrapper horizontalMenu">
        <div className="flex flex-col justify-between min-h-screen">
          <div>
            {/* Header */}
            <div className="z-[9]" id="app_header">
              <div className="app-header z-[999] ltr:ml-[248px] rtl:mr-[248px] bg-qualtia">
                <div className="flex items-center justify-between px-4 py-2 bg-qualtia ">

                  {/* Logo */}
                  <a href="/carga-dme">
                    <img
                      src="assets/images/logo/logo.png"
                      alt="logo"
                      className="h-10 w-auto"
                    />
                  </a>   
                  <div className="flex items-center gap-3 animate-fade-in">
                    <Icon icon="mdi:cart-remove" className="text-white text-3xl" />
                    <h2 className="text-white text-2xl font-bold  relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-10 after:h-1">
                      Devolución Mal Estado

                    </h2>
                  </div>

                  {/* Herramientas de navegación */}
                  <div className="nav-tools flex items-center space-x-5 rtl:space-x-reverse">
                    {/* Notificaciones Draggable */}
                    <div className="relative md:block hidden">
                      

                      {open && (
                        <Draggable
                          nodeRef={menuRef}
                          handle=".handle"
                          defaultPosition={{ x: 0, y: 0 }}
                          onStart={() => setDragging(true)}
                          onStop={() =>
                            setTimeout(() => {
                              setDragging(false);
                            }, 100)
                          }
                          cancel="input,textarea,button,select,option,a"
                        >
                          <div
                            ref={menuRef}
                            className="dropdown-menu z-[9999] bg-white shadow w-[335px] border  absolute mt-1 rounded-md overflow-hidden"
                            role="menu"
                            style={{ top: '23px', position: 'absolute' }}
                          >
                            <div className="handle flex items-center justify-between py-4 px-4 cursor-move">
                              <h3 className="text-sm font-medium text-slate-700 ">
                                Notifications
                              </h3>
                              <a
                                href="#"
                                onClick={(e) => e.preventDefault()}
                                className="text-xs underline text-slate-500 "
                              >
                                See All
                              </a>
                            </div>
                            <div className="" role="none">
                              <div className="bg-slate-100 text-slate-800 block w-full px-4 py-2 text-sm relative">
                                <div className="flex ltr:text-left rtl:text-right">
                                  <div className="flex-none ltr:mr-3 rtl:ml-3">
                                    <div className="h-8 w-8 bg-white rounded-full">
                                      <img src="/assets/images/all-img/user.png" alt="user" className="border-white block w-full h-full object-cover rounded-full border"/>
                                    </div>
                                  </div>
                                  <div className="flex-1">
                                    <a href="#" className="text-slate-600  text-sm font-medium mb-1 before:w-full before:h-full before:absolute before:top-0 before:left-0">
                                      Your order is placed</a>
                                    <div className="text-slate-500  text-xs leading-4">Amet minim mollit non deser unt ullamco est sit
                                      aliqua.</div>
                                    <div className="text-slate-400 text-xs mt-1">
                                      3 min ago
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Draggable>
                      )}
                    </div>

                    {/* Dropdown Perfil Usuario */}
                    <div className="md:block hidden w-full relative" ref={dropdownPerfilRef}>
                      <button
                        type="button"
                        aria-expanded={open2}
                        aria-haspopup="true"
                        onClick={() => setOpen2((prev) => !prev)}
                        className="text-slate-800  font-medium rounded-lg text-sm inline-flex items-center"
                      >
                        <span className="hidden text-left lg:inline-block text-sm font-normal text-white  truncate max-w-[150px]">
                          {user.name ?? ''} <br/>
                          {user.username??''}
                        </span>
                        <svg
                          className="w-4 h-4 ml-2 rtl:mr-2 "
                          fill="none"
                          stroke="white"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>

                      {open2 && (
                        <div
                          className="dropdown-menu z-100 bg-white divide-y divide-slate-100 shadow w-44 absolute mt-1 right-0 rounded-md overflow-hidden"
                          role="menu"
                          style={{ top: '23px' }}
                        >
                          <ul className="py-1 text-sm text-slate-800 ">
                            {/* Más items */}
                            <li>
                                <button
                                  onClick={handleLogout}
                                  className="w-full text-left block px-4 py-2 hover:bg-slate-100 flex items-center"
                                >
                                  <Icon icon="heroicons-outline:login" className="text-lg mr-1 rtl:ml-1" />
                                  Logout
                                </button>                              
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Navbar/>
            </div>

            {/* Content */}
            <div className="content-wrapper transition-all duration-150 ltr:ml-[248px] rtl:mr-[248px]" >
              <div className="page-content bg-gray">
                <div className="transition-all duration-150 container-fluid" >
                  <div id="content_layout">
                    { children}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <footer className="md:block hidden" id="footer">
            <div className="site-footer px-6 bg-white text-slate-500 py-4 ltr:ml-[248px] rtl:mr-[248px]">
              <div className="grid md:grid-cols-2 grid-cols-1 md:gap-5">
                <div className="text-left ltr:md:text-start rtl:md:text-right text-sm">
                  COPYRIGHT {currentYear} Qualtia, All rights Reserved
                </div>
              </div>
            </div>
          </footer>
        </div>
      </main>
  );
};

export default Layout;
